import { get, post, remove, patch } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchMenuTemplates =
  (force = false) =>
  (dispatch, getState) =>
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
    new Promise((resolve, reject) => {
      if (!force && getState().MenuTemplates.menuTemplates.length > 0) {
        resolve({ menuTemplates: getState().MenuTemplates.menuTemplates });

        // eslint-disable-next-line no-promise-executor-return -- FIXME
        return getState().MenuTemplates.menuTemplates;
      }

      if (getState().MenuTemplates.loading) {
        // eslint-disable-next-line consistent-return -- FIXME
        return;
      }

      dispatch({
        type: types.LOADING_MENU_TEMPLATES,
        payload: {
          loading: true,
        },
      });
      // eslint-disable-next-line no-promise-executor-return, promise/prefer-await-to-then -- FIXME
      return get('/menu-templates', { pagination: false }).then(response => {
        dispatch({
          type: types.FETCH_MENU_TEMPLATES,
          payload: {
            menuTemplates: response['hydra:member'],
          },
        });
        dispatch({
          type: types.LOADING_MENU_TEMPLATES,
          payload: {
            loading: false,
          },
        });
        resolve({ menuTemplates: response['hydra:member'] });

        return response['hydra:member'];
      });
    });

export const fetchMenuTemplate = date => dispatch =>
  new Promise((resolve, reject) => {
    get('/menu-templates', { date })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(menuTemplates => {
        let menuTemplate;
        if (menuTemplates['hydra:member'].length > 0) {
          menuTemplate = menuTemplates['hydra:member'][0];
          resolve({ menuTemplate });
        } else {
          menuTemplate = { name: '' };
        }

        dispatch({
          type: types.FETCH_MENU_TEMPLATE,
          payload: { menuTemplate },
        });
      })
      // eslint-disable-next-line promise/prefer-await-to-then, promise/prefer-await-to-callbacks -- FIXME
      .catch(err => {
        // eslint-disable-next-line no-use-before-define -- FIXME
        dispatch(resetMenuTemplate());
        reject(err);
      });
  });

export const createMenuTemplate = data => dispatch =>
  new Promise((resolve, reject) => {
    post('/menu-templates', data)
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(menuTemplate => {
        dispatch({
          type: types.CREATE_MENU_TEMPLATE,
          payload: menuTemplate,
        });
        resolve(menuTemplate);
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .catch(reject);
  });

export const removeMenuTemplate = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  remove(`/menu-templates/${id}`).then(() => {
    dispatch({
      type: types.REMOVE_MENU_TEMPLATE,
      payload: {
        menuTemplateId: id,
      },
    });
  });

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
export const applyMenuTemplate = (id, date) => dispatch =>
  new Promise((resolve, reject) => {
    patch(`/menu-templates/${id}/apply/${date}`, {})
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(data => {
        resolve(data);
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .catch(reject);
  });

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
export const resetMenuTemplates = () => dispatch => ({
  type: types.RESET_MENU_TEMPLATES_STATE,
  payload: {
    menuTemplates: [],
  },
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
export const resetMenuTemplate = () => dispatch => ({
  type: types.RESET_MENU_TEMPLATE_STATE,
  payload: {
    menuTemplate: { name: '' },
  },
});
